export default "__VITE_ASSET__DqO2ou0i__"